import { DatesHelpers } from "@core/helpers";
import { i18n } from "@core/plugins/i18n";

export const ITopRecommendation = {
  comment: "comment",
  commentBy: "comment_by",
  end: "fin_experience",
  etabCategory: "categorie_etab",
  etabName: "nom_etab",
  note: "note",
  qualificationName: "nom_poste",
  start: "debut_experience",
};

export class TopRecommendationModel {
  constructor(data = {}) {
    this[ITopRecommendation.comment] = data[ITopRecommendation.comment];
    this[ITopRecommendation.commentBy] = data[ITopRecommendation.commentBy];
    this[ITopRecommendation.end] = data[ITopRecommendation.end];
    this[ITopRecommendation.etabCategory] = data[ITopRecommendation.etabCategory];
    this[ITopRecommendation.etabName] = data[ITopRecommendation.etabName];
    this[ITopRecommendation.note] = data[ITopRecommendation.note];
    this[ITopRecommendation.qualificationName] = data[ITopRecommendation.qualificationName];
    this[ITopRecommendation.start] = data[ITopRecommendation.start];
  }

  getCommentLength() {
    return (this[ITopRecommendation.comment] || "").length;
  }

  getComment() {
    return this[ITopRecommendation.comment];
  }

  getCommenter() {
    return this[ITopRecommendation.commentBy];
  }

  getQualificationName() {
    return this[ITopRecommendation.qualificationName];
  }

  getEtabIdentity() {
    return `${this[ITopRecommendation.etabName]}, ${this[ITopRecommendation.etabCategory]}`;
  }

  getDatesDisplay() {
    const start = this[ITopRecommendation.start] ? DatesHelpers.getDayjs(this[ITopRecommendation.start]) : null;
    const end = this[ITopRecommendation.end] ? DatesHelpers.getDayjs(this[ITopRecommendation.end]) : null;
    let display = "";
    if (start) {
      display += start.format("MMM YYYY");
      if (end) {
        // if start and end are not in the same month, we display the end date
        if (!start.isSame(end, "month")) {
          display += ` ${i18n.global.t("CORE.MODELS.RECOMMENDATION.@TOP_RECO_END_DATE", { date: end.format("MMM YYYY") })}`;
        }
      } else {
        // if there's no end date, it means it's still in progress
        display += ` ${i18n.global.t("CORE.MODELS.RECOMMENDATION.@TOP_RECO_IN_PROGRESS")}`;
      }
    }

    return display;
  }
}
